module.exports = ".deadline{color:red}\n"